import { render, staticRenderFns } from "./ClusterResultCard.vue?vue&type=template&id=04d33948&scoped=true&"
import script from "./ClusterResultCard.vue?vue&type=script&lang=js&"
export * from "./ClusterResultCard.vue?vue&type=script&lang=js&"
import style0 from "./ClusterResultCard.vue?vue&type=style&index=0&id=04d33948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d33948",
  null
  
)

export default component.exports